"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StandingRoute = function StandingRoute(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m12 0a12 12 0 1 0 12 12 12 12 0 0 0 -12-12z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    fill: "#fff",
    height: "12",
    rx: ".6",
    width: "12",
    x: "6",
    y: "6"
  }));
};

StandingRoute.propTypes = {
  className: _propTypes["default"].string
};
StandingRoute.defaultProps = {
  className: 'fill-primary'
};
var _default = StandingRoute;
exports["default"] = _default;